import { render } from "./ClaimNFT.vue?vue&type=template&id=d4fa736e&scoped=true"
import script from "./ClaimNFT.vue?vue&type=script&lang=js"
export * from "./ClaimNFT.vue?vue&type=script&lang=js"

import "./ClaimNFT.vue?vue&type=style&index=0&id=d4fa736e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4fa736e"]])

export default __exports__